module.exports = __webpack_public_path__ + "static/media/face.ddb46d7b.svg";